import checkNativeVersion from '@/common/contact-selector/utils/checkNativeVersion';
import isMobile from '@/common/contact-selector/utils/isMobile';
import getDatasourceByType from './utils/getDatasourceByType';
import filters from '../filters';
import convertList from '../convertList';

function getTroopMemberList(config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        getDatasourceByType({
            type: 'TroopMember',
            cancelConvertList: true
        })
            .then(list => {
                const filterList = filters.filterTroopList(list, selfConfig, 'group');
                resolve(
                    convertList(
                        filterList,
                        {
                            list: 'memberList',
                            groupName: 'name'
                        },
                        {
                            ...config,
                            // 对分组进行处理，如果是当前群组会打上标记，方便在群后面显示当前群逻辑
                            transformGroup(originItem) {
                                const item = originItem;
                                try {
                                    if (`${config.extendConfig.triggerInfo.id}` === `${item.id}`) {
                                        item.isCurrentGroup = true;
                                    }
                                } catch (err) {
                                    // no catch
                                }
                                return item;
                            }
                        }
                    )
                );
            })
            .catch(err => {
                reject(err);
            });
    });
}

function getTroopList(config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        getDatasourceByType({
            type: 'Troop',
            params: {
                needTroopGroup: 0
            },
            cancelConvertList: true
        })
            .then(list => {
                console.log('getDatasourceByType troopMember');
                const filterList = filters.filterTroopList(list, selfConfig, 'group');
                const newList = filterList.map(originItem => {
                    const item = originItem;
                    item.list = null;
                    return item;
                });
                console.log(newList);
                resolve(
                    convertList(
                        newList,
                        {
                            groupName: 'name'
                        },
                        {
                            ...config,
                            totalState: false,
                            // 对分组进行处理，如果是当前群组会打上标记，方便在群后面显示当前群逻辑
                            transformGroup(originItem) {
                                const item = originItem;
                                try {
                                    if (`${config.extendConfig.triggerInfo.id}` === `${item.id}`) {
                                        item.isCurrentGroup = true;
                                    }
                                } catch (err) {
                                    // no catch
                                }
                                return item;
                            }
                        }
                    )
                );
            })
            .catch(err => {
                reject(err);
            });
    });
}

export default function(config) {
    // 3.7以后版本不再支持全量拉取群成员
    // 运营包3.6.0.16856版本也不支持全量拉取群成员
    if (
        (checkNativeVersion({
            version: '3.7.0',
            operator: 'gt'
        }) ||
            checkNativeVersion({
                version: '3.7.0',
                operator: 'eq'
            }) ||
            checkNativeVersion({
                version: '3.6.16856',
                operator: 'eq'
            })) &&
        !isMobile()
    ) {
        return getTroopList(config);
    }
    return getTroopMemberList(config);
}
